import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faGamepad,
  faArrowCircleUp,
  faArrowCircleDown,
  faUserCircle,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';

type Tab = { to: string; labelKey: string; icon: IconDefinition; tourId: string };

const TABS: Tab[] = [
  { to: '/home', labelKey: 'nav.home', icon: faHome, tourId: 'tab-home' },
  { to: '/games', labelKey: 'nav.games', icon: faGamepad, tourId: 'tab-games' },
  { to: '/topup', labelKey: 'nav.topup', icon: faArrowCircleUp, tourId: 'tab-topup' },
  { to: '/withdraw', labelKey: 'nav.withdraw', icon: faArrowCircleDown, tourId: 'tab-withdraw' },
  { to: '/profile', labelKey: 'nav.profile', icon: faUserCircle, tourId: 'tab-profile' },
];

const HIDDEN_PATHS = ['/wallet-topup', '/notifications', '/notification-prefs', '/faq', '/help', '/order'];

export default function BottomTabBar() {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const location = useLocation();

  if (HIDDEN_PATHS.some(p => location.pathname.startsWith(p))) return null;

  return (
    <div
      data-tour="bottom-nav"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: `calc(68px + env(safe-area-inset-bottom, 0px))`,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        backgroundColor: colors.tabBar,
        borderTop: `1px solid ${colors.tabBarBorder}`,
        display: 'flex',
        zIndex: 100,
      }}
    >
      {TABS.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          data-tour={tab.tourId}
          style={({ isActive }) => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 4,
            paddingTop: 6,
            paddingBottom: 10,
            color: isActive ? colors.accentDark : colors.textMuted,
            textDecoration: 'none',
            fontSize: 10,
            fontWeight: 800,
          })}
        >
          {({ isActive }) => (
            <>
              <FontAwesomeIcon
                icon={tab.icon}
                style={{ fontSize: 20, color: isActive ? colors.accentDark : colors.textMuted }}
              />
              <span>{t(tab.labelKey)}</span>
            </>
          )}
        </NavLink>
      ))}
    </div>
  );
}
